import React from 'react';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import {
  calcAtomBLCountByFullLinks,
  calcEstimatedAtomQuantityCount,
  calcEstimatedSPProfitability,
  calcActualSPProfitability,
  validate,
} from './../expenses/ExpensesUtils';
import {
  REF_PATH as BUYER_TERM_REF_PATH }
  from '../../../dict/simple/buyer/Const';
import {
  REF_PATH as SUPPLIER_TERM_REF_PATH }
  from '../../../dict/simple/supplier/Const';
import {
  REF_PATH as EXPENSESTYPE_REF_PATH }
  from '../../../dict/complex/expensestype/Const';
import {
  Col,
  Row,
} from 'react-bootstrap';
import {
  getSimpleListWrapper,
} from '../../../dict/simple/SimpleWrapper';
import { formatNumber } from '../elements/BaseElement';

import {
  REF_NAME as DELIVERY_TERM_REF_NAME,
  REF_PATH as DELIVERY_TERM_REF_PATH }
  from '../../../dict/simple/deliveryterm/Const';
import RoleConfigFilter from '../../../auth/RoleConfigFilter.jsx';

import { putPLTotal } from '../store/pltab.store';

class ExpensesTotal extends React.Component {
  constructor(props) {
    super(props);
    this.calcProfitabilities = this.calcProfitabilities.bind(this);
    this.state = {
      totalActualProfitability: 0.0,
      totalEstimatedProfitability: 0.0,
    };
  }

  componentDidMount() {
    getSimpleListWrapper(DELIVERY_TERM_REF_NAME, DELIVERY_TERM_REF_PATH);
    this.calcProfitabilities(this.props);
  }

  componentWillReceiveProps(props) {
    this.calcProfitabilities(props);
  }

  calcProfitabilities(props) {
    if (props.products && props.dealType && props.deals && props.deliveryTerms) {
      // список атомов
      const atoms = props.products;

      // quantities
      let totalActualBLQuantity = 0;
      let totalEstimatedQuantity = 0;

      // прибыльность
      let totalEstimatedProfitability = 0.0;

      let totalActualProfitabilityPT = 0.0;
      let totalActualProfitabilityLS = 0.0;

      let hasActualErrors = false;
      let hasEstimateErrors = false;
      atoms.forEach((atom) => {
        // проверить продукт на hidden
        if (atom.get('hidden') != true && (!hasActualErrors || !hasEstimateErrors)) {
          // -------------------------
          // actual
          // -------------------------

          const errors = validate(atom,
            props.dealType,
            null,
            props.deals,
            props.deal,
            props.expensesTypes,
            props.deliveryTerms,
            props.buyers,
            props.suppliers);
          hasEstimateErrors = hasEstimateErrors || errors.estimatedErrors.length > 0;
          hasActualErrors = hasActualErrors || errors.actualErrors.length > 0;
          const actualBLQuantity = calcAtomBLCountByFullLinks(atom, props.dealType);

          totalActualBLQuantity += actualBLQuantity;
          const actualPT = calcActualSPProfitability(
            atom,
            props.dealType,
            props.deals,
            atom.get('expenses', new List()));
          totalActualProfitabilityPT +=
            actualBLQuantity * actualPT;

          // -------------------------
          // estimated
          // -------------------------

          const estimatedQuantity =
            calcEstimatedAtomQuantityCount(
              atom,
              props.dealType,
              props.deals,
              props.deliveryTerms);
          totalEstimatedQuantity += estimatedQuantity;
          const estimatedPTprofit = calcEstimatedSPProfitability(
            atom,
            props.dealType,
            props.deals,
            props.deliveryTerms,
            atom.get('expenses', new List()));
          totalEstimatedProfitability +=
            estimatedQuantity * estimatedPTprofit;
          if (estimatedPTprofit) {
            this.props.putPLTotal(atom.get('id'), 'estimated', estimatedPTprofit);
          }
          if (actualPT) {
            this.props.putPLTotal(atom.get('id'), 'actualPT', actualPT);
          }
          if (actualPT && actualBLQuantity) {
            this.props.putPLTotal(atom.get('id'), 'actualLS', actualBLQuantity * actualPT);
          }
          if (actualBLQuantity) {
            this.props.putPLTotal(atom.get('id'), 'bl', actualBLQuantity);
          }
        }
      });

      totalActualProfitabilityLS = totalActualProfitabilityPT / totalActualBLQuantity;

      totalEstimatedProfitability =
        totalEstimatedQuantity
          ? totalEstimatedProfitability / totalEstimatedQuantity
          : 0.0;
      this.setState({
        totalActualProfitabilityPT: hasActualErrors ? 'N/A' : totalActualProfitabilityPT,
        totalActualProfitabilityLS: hasActualErrors ? 'N/A' : totalActualProfitabilityLS,
        totalEstimatedProfitability: hasEstimateErrors ? 'N/A' : totalEstimatedProfitability,
      });
      this.props.putPLTotal('deal', 'estimated',
        hasEstimateErrors ? 'N/A' : totalEstimatedProfitability);
      this.props.putPLTotal('deal', 'actualLS',
        hasActualErrors ? 'N/A' : totalActualProfitabilityPT);
      this.props.putPLTotal('deal', 'actualPT',
        hasActualErrors ? 'N/A' : totalActualProfitabilityLS);
      this.props.putPLTotal('deal', 'bl', totalActualBLQuantity);
    }
  }

  render() {
    return (
      <RoleConfigFilter permissions={['viewProfitability']}>
        <Col
          xs={12}
          className="expenses-total"
          style={{
            display: this.props.products &&
           this.props.products.filter(p => !p.get('hidden')).size == 1 ? 'none' : '',
          }}
        >
          <Row className={'expenses-total-label'}>
            <Col md={6}>
                Deal profitability
            </Col>
            <Col md={6}>
              <Row>
                <Col
                  md={6}
                >
                  Estimated
                </Col>
                <Col
                  md={6}
                >
                  Actual
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className={'expenses-total-values'}>
            <Col className="text-right" md={6}>
              <div className={'expenses-total-value-item'} style={{ justifyContent: 'flex-end' }}>
                $
              </div>
            </Col>
            <Col md={6}>
              <Row>
                <Col
                  id="profitabilityEstimatedDeal"
                  md={6}
                  className={'expenses-total-value-item'}
                >
                  {isNaN(this.state.totalEstimatedProfitability) ?
                    this.state.totalEstimatedProfitability :
                    formatNumber(this.state.totalEstimatedProfitability, '0,0.00')}
                </Col>
                <Col
                  id="profitabilityActualDeal"
                  md={6}
                  className={'expenses-total-value-item'}
                >
                  {isNaN(this.state.totalActualProfitabilityPT) ?
                    '' :
                    `(${formatNumber(this.state.totalActualProfitabilityPT, '0,0.00')}) `}
                  {isNaN(this.state.totalActualProfitabilityLS) ?
                    this.state.totalActualProfitabilityLS :
                    formatNumber(this.state.totalActualProfitabilityLS, '0,0.00')}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </RoleConfigFilter>);
  }
}

ExpensesTotal.propTypes = {
  dealType: React.PropTypes.string,
  products: React.PropTypes.object,
  deal: React.PropTypes.object,
  deals: React.PropTypes.object,
  expensesTypes: React.PropTypes.object,
  buyers: React.PropTypes.object,
  suppliers: React.PropTypes.object,
  deliveryTerms: React.PropTypes.object,
  putPLTotal: React.PropTypes.func,
};

export default connect(
  (state) => ({
    products: state.getIn(['data', 'deals', 'deal', 'products'], new List()),
    deals: state.getIn(['data', 'deals', 'list'], new Map()),
    deliveryTerms: state.getIn(['references', 'simple', DELIVERY_TERM_REF_PATH], new List()),
    expensesTypes: state.getIn(['references', 'simple', EXPENSESTYPE_REF_PATH], new List()),
    buyers: state.getIn(['references', 'simple', BUYER_TERM_REF_PATH], new List()),
    suppliers: state.getIn(['references', 'simple', SUPPLIER_TERM_REF_PATH], new List()),
  }), dispatch => ({
    putPLTotal(elementId, totalType, value) {
      putPLTotal(dispatch, elementId, totalType, value);
    },
  })
)(ExpensesTotal);
